import React from 'react';
import styled from 'styled-components';

// import { useActiveWindowInterval } from '#/components/hooks';
import { useIsMobileBuySellRoute } from '#/components/trading/dashboardDetect';

import OrderbookTableBody from './OrderbookTableBody';
import { DashboardTableHeader } from './sharedCss';

// TODO: cleanup

const TableBodyWrap = styled.div`
  /* flex: 1; */
  /* position: relative; */
  /* overflow: hidden; */
`;

const TableBody = styled.div`
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; */
  /* overflow-y: scroll; */
  /* overflow-y: hidden; */
  /* $ {scrollbarStyle} */
`;

/**
 * We want to disable tooltips until scrolling is active.
 * Delayed by 500ms after scroll end.
 */
// function useScrollDelay() {
//   const lastScroll = useRef(0);
//   const [scrollDelay, setScrollDelay] = useState(false);

//   useActiveWindowInterval(() => {
//     if (!scrollDelay) {
//       return;
//     }
//     if (Date.now() - lastScroll.current > 500) {
//       setScrollDelay(false);
//     }
//   }, 400);

//   const handleScroll = useCallback(() => {
//     lastScroll.current = Date.now();
//     if (!scrollDelay) {
//       setScrollDelay(true);
//     }
//   }, [scrollDelay]);

//   return { scrollDelay, handleScroll };
// }

const OrderbookTable = ({
  userTickSizeInDecimals,
}: {
  userTickSizeInDecimals: string | undefined;
}) => {
  // const { scrollDelay, handleScroll } = useScrollDelay();
  const isMobileBuySellRoute = useIsMobileBuySellRoute();
  return (
    <>
      <DashboardTableHeader $minimal={isMobileBuySellRoute}>
        <div>Price</div>
        {!isMobileBuySellRoute && <div>Quantity</div>}
        <div>{isMobileBuySellRoute ? 'Total USD' : 'Total'}</div>
      </DashboardTableHeader>
      <TableBodyWrap>
        {/* <TableBodyWrap onScrollCapture={handleScroll}> */}
        <TableBody>
          {userTickSizeInDecimals && (
            <OrderbookTableBody
              userTickSizeInDecimals={userTickSizeInDecimals}
              // summaryTooltipEnabled={!scrollDelay}
              summaryTooltipEnabled={true}
              minimalLayout={isMobileBuySellRoute}
            />
          )}
        </TableBody>
      </TableBodyWrap>
    </>
  );
};

export default OrderbookTable;
